import { oaExamineSaveAndUpdateAPI } from '@/api/oa/examine'
import { guid } from '@/utils'

export default {
  data() {
    return {
      // 审批模版版本
      batchId: guid()

    }
  },

  methods: {
    /**
     * 快速发起特殊审批
     * @param examineType 审批类型 1 潜在联系人转为精准联系人 2 精准联系人转KP  3 联系人取消KP  4线索企业转为精准企业
     * @param oaExamineRelation 业务ID eg: {contactsIds:1111}
     * @param examineId 审批模版ID
     * @param content 审批事由
     * @param remark 备注
     */
    postSpecialExamine(examineType = null, oaExamineRelation = {}, examineId = '', content = '', remark = '', callback) {
      const params = {
        examineFlowData: {
          dataMap: {},
          examineId,
          label: 0,
          optionalList: []
        },
        field: [],
        oaExamine: {
          batchId: this.batchId,
          categoryId: examineId,
          content,
          remark
        },
        examineType,
        oaExamineRelation
      }
      oaExamineSaveAndUpdateAPI(params).then(() => {
        this.$crmMessage.success('发起审批成功')
        callback && callback()
      })
    }
  },

  deactivated: function() { }

}
